<script setup lang="ts">
// The frame for screens before you're in: a measured field with one panel on it.
defineProps<{ testid?: string; caption?: string }>()
</script>

<template>
  <main class="field-grid flex min-h-full items-center justify-center p-4" :data-testid="testid">
    <div class="w-full max-w-sm border border-border-strong bg-bg-primary">
      <div class="flex h-11 items-center justify-between border-b border-border px-5">
        <span class="flex items-center gap-3">
          <img src="/favicon.svg" alt="" class="h-4 w-4" />
          <span class="mono tracking-[0.4em] text-text-primary">HRTH</span>
        </span>
        <span class="mono text-[10px] tracking-[0.12em] text-text-muted uppercase">{{ caption ?? 'e2ee · self-hosted' }}</span>
      </div>
      <div class="p-6">
        <slot />
      </div>
    </div>
  </main>
</template>
